import React from "react";
import { Box, Stepper, Step, StepLabel, Typography, styled } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

// Labels dos passos
const steps = ["Conteúdo (miolo)", "Capa", "Informações", "Finalizar Edição", "Publicar"];

const StepsContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  background: "#ffffff",
  border: "1px solid #dbe3ef",
  borderRadius: 8,
  padding: "22px 20px 18px",
  boxShadow: "0 10px 28px rgba(15, 23, 42, 0.07)",
  overflowX: "auto",
  overflowY: "hidden",
  "&::-webkit-scrollbar": {
    height: 6,
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(91, 110, 132, 0.24)",
    borderRadius: 999,
  },
  [theme.breakpoints.down("md")]: {
    padding: "18px 14px 16px",
  },
}));

const StyledStepper = styled(Stepper)(({ theme, ownerState }) => {
  const progress = ownerState.progress;

  return {
    background: "transparent !important",
    backgroundColor: "transparent !important",
    boxShadow: "none !important",
    borderRadius: "0 !important",
    padding: "8px 0 4px !important",
    minWidth: 820,
    minHeight: 68,
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      left: "10%",
      right: "10%",
      top: 17,
      height: 3,
      borderRadius: 999,
      backgroundColor: "#d7dee8",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: "10%",
      top: 17,
      width: `${progress * 80}%`,
      height: 3,
      borderRadius: 999,
      background: "#087f23",
      transition: "width 260ms ease",
    },
    "& .MuiStepConnector-line": {
      borderColor: "transparent",
    },
    "& .MuiStep-root": {
      position: "relative",
      zIndex: 1,
    },
  };
});

const StepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor: ownerState.completed ? "#2f7d62" : ownerState.active ? "#087f23" : "#ffffff",
  color: ownerState.completed || ownerState.active ? "#fff" : "#65758b",
  border: ownerState.completed
    ? "2px solid #2f7d62"
    : ownerState.active
    ? "2px solid #087f23"
    : "2px solid #c8d5e5",
  zIndex: 1,
  width: 32,
  height: 32,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: 900,
  fontSize: 12,
  boxShadow: ownerState.active
    ? "0 8px 18px rgba(8, 127, 35, 0.24)"
    : "0 4px 12px rgba(15, 23, 42, 0.08)",
  transition: "all 200ms ease",
}));

function CustomStepIcon(props) {
  const { active, completed, icon } = props;
  return (
    <StepIconRoot ownerState={{ active, completed }}>
      {completed ? <CheckIcon sx={{ fontSize: 18, color: "#fff" }} /> : icon}
    </StepIconRoot>
  );
}

// Cabeçalho de passos
function PublishStepsHeader({ activeStep = 0 }) {
  const progress =
    steps.length > 1 ? Math.min(Math.max(activeStep, 0), steps.length - 1) / (steps.length - 1) : 0;

  return (
    <StepsContainer>
      <StyledStepper alternativeLabel activeStep={activeStep} ownerState={{ progress }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={CustomStepIcon}
              sx={{
                "& .MuiStepLabel-label": {
                  fontSize: "12px !important",
                  fontWeight: "800 !important",
                  color: "#7b8797 !important",
                  mt: "12px !important",
                  whiteSpace: "nowrap",
                  textTransform: "uppercase",
                  letterSpacing: 0,
                  "&.Mui-active": {
                    fontWeight: "900 !important",
                    color: "#1f2a37 !important",
                  },
                  "&.Mui-completed": {
                    color: "#087f23 !important",
                  },
                },
              }}
            >
              <Typography component="span" variant="caption" fontWeight="inherit" color="inherit">
                {label}
              </Typography>
            </StepLabel>
          </Step>
        ))}
      </StyledStepper>
    </StepsContainer>
  );
}

export default PublishStepsHeader;
